import { useEffect, useState } from "react";
import { Output } from "valibot";

import { useGlobalsContext } from "shared/hooks";
import { requestBackend } from "shared/request";
import { BotVariablesSchema, VariablesRecordSchema } from "shared/schemas";

function useBotVariables(token: string) {
  const { setVariables } = useGlobalsContext();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    requestBackend("/v1/botsonic/widget/bot-variables", {
      headers: {
        token,
      },
      schema: BotVariablesSchema,
    })
      .then(
        data => {
          setVariables(state => {
            const parsedVariables: Output<typeof VariablesRecordSchema> =
              Object.fromEntries(
                data.variables.map(({ key, fallback }) => [
                  key,
                  {
                    key,
                    value: "",
                    fallback: fallback || "",
                  },
                ]),
              );

            return {
              ...state,
              ...parsedVariables,
            };
          });
        },
        err => {
          // eslint-disable-next-line no-console
          console.error(err);
        },
      )
      .finally(() => setLoading(false));
  }, [token, setVariables]);

  return {
    loading,
    error,
  };
}

export default useBotVariables;
